import axios from "../utils/axios";

// 🏢 Get location list
export const getLocationList = async (payload) => {
  const response = await axios.post("/api/Location/GetList", payload);
  return response.data;
};

// 🏢 Get location details
export const getLocationDetails = async (targetId) => {
  const response = await axios.get("/api/Location/GetDetails", {
    params: { targetId },
  });
  return response.data;
};
